import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import TypedLink from '../TypedLink/TypedLink.js';
import { Utils } from '../../Utils.js';
import ProductListItem from '../../components/ProductListItem/ProductListItem.js';

import './Search.css';

class Search extends React.Component {

  emptyFormData = {
    term: '',
  };

  typeing_interval = null;

  constructor(props) {
      super(props);

      this.state = {
        show: false,
        show_results: false,
        formData: { ...this.emptyFormData },
        products:{},
        categories:{},
        searchListUrl:''
      }
  }

  show() {
    this.setState({show: true});
  }

  hide() {
    const formData = this.state.formData;

    formData.term = '';

    this.setState({show: false, formData: formData, show_results: false});
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  show_results() {
    window.AppFooterMenuRef.current.hide_all_menu_item();
    this.setState({show_results: true});
  }

  hide_results() {
    this.setState({show_results: false});
  }

  handle_change(event, formDataKey, force_value = null) {
    
    if(this.typeing_interval){
      clearTimeout(this.typeing_interval);
    }

    const formData = this.state.formData;
    formData[formDataKey] = force_value !== null ? force_value : event.target.value;
    this.setState({formData});

    this.typeing_interval = setTimeout(()=>{
      this.get_search_data();
    },1000);

  }

  get_search_data(){

    if(this.state.formData.term && this.state.formData.term.length<3){
      return false;
    }
    Utils.get_server_data('', { APICACHE:'false', search_keywords: this.state.formData.term }, { ajax_event: 'search_products', search_keywords: this.state.formData.term })
    .then((res)=>{
      this.setState({products:res.products,categories:res?.search_categories,searchListUrl:res?.search_list_url},()=>this.show_results());
    });

  }

  render() {
    const {formData, show, show_results } = this.state;

    if(!show) return '';
  
    return <>
    
      <div className="search">
        <ReactSVG className="icon" src={`assets/images/search.svg`} />
        <input autoFocus placeholder={`${i18n.t('searchPlaceholder')}`} type="text" value={formData.term} onChange={(e) => this.handle_change(e, 'term')} />
        <ReactSVG onClick={(e) => this.toggle()} className="icon close" src={`assets/images/close.svg`} />
        <button className="button" onClick={() => this.toggle()} type="button">{i18n.t("searchCancel")}</button>
      </div>

      {show_results ? <div className="search_results">
        
        {this.state.categories ? 
          <div className="search_results_block categories">
            <label>{i18n.t('searchCategories')}</label>
            <div className="items">
              {this.state.categories && this.state.categories.map(category => <TypedLink key={category.url} link={{type:'products', url: category.url, title: category.category}}></TypedLink>)} 
            </div>
          </div>
        : ''}
          
        <div className="search_results_block products">
          <label>{i18n.t('searchProducts')}</label>
          <div className="items">
            <div className='product-list-items-cont'>
              {this.state.products.list.products && this.state.products.list.products.length>0 ? this.state.products?.list?.products.map(product => <ProductListItem key={`${product.id}`} product={product} />) : i18n.t('searchNoresult')}    
            </div>
          </div>
          {this.state.searchListUrl ?
            <div className='search_page_url'>
              <TypedLink link={{type:'products', url: this.state.searchListUrl, title: i18n.t('searchAllItemsURL')}}></TypedLink>
            </div> 
           : ''}
        </div>
      </div> : ''}

    </>;
  }
}

export default Search;

